import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch } from "react-redux";
import { setData } from "../../redux/actions";
import AdminNav from './AdminNav';
import AdminSidebar from './AdminSidebar';
import ActiveNoticeModal from './ActiveNoticeModal';

function AdminLayout() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getData = async () => {
    try {
      const response = await axios.post('/user/loggedinuser');
      const { status, user, prabhuMoneyTransfer, prabhuCspOnboarding, imeMoneyTransfer, imeCspOnboarding } = response.data;
      if (status) {
        dispatch(setData({ ...user, prabhuMoneyTransfer, prabhuCspOnboarding, imeMoneyTransfer, imeCspOnboarding }));
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
    let deviceId = localStorage.getItem("deviceId");
    let token = localStorage.getItem("token");
    if (!deviceId && !token) {
      navigate('/login');
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const setCallbackStatus = (callbackStatus) => {
    setSidebarOpen(callbackStatus);
  };

  return (
    <>
      <div class="container-scroller">
        <AdminNav onToggleSidebar={toggleSidebar} />
        <div class="container-fluid page-body-wrapper">
          <AdminSidebar isOpen={isSidebarOpen} callback={setCallbackStatus} />
          <div class="main-panel">
            <Outlet />
            <footer class="footer">
              <div class="d-sm-flex justify-content-center justify-content-sm-between">
                <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">
                  &copy; 2025 Pargati Online Services. All rights reserved.
                </span>
                <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
                  Powered by Pargati Technologies
                </span>
              </div>
            </footer>
          </div>
        </div>
      </div>
      <ActiveNoticeModal />
      <ToastContainer />
    </>
  );
}

export default AdminLayout;
